module.exports = __webpack_public_path__ + "static/media/Walk-through_Trending_6.2a06e5ee.jpg";